// HTN Regimen status glyphs (2026-07-02). Kept OUT of the auto-generated
// drugIcons.js so a recraft regen never clobbers them. RecraftGlyph falls back
// here when a slug is not a generated gold-card glyph. Same contract as
// DRUG_ICONS: viewBox + fill=currentColor paths. To promote to a recraft-exact
// asset later, drop the SVG in /home/edward/recraft-icons/ and move the entry.
export const HTN_REGIMEN_ICONS = {
  diuresis: { // droplet — Diuresis DoT drain
    viewBox: "0 0 24 24",
    paths: [
      "M12 2.4 C12 2.4 4.7 12.1 4.7 16.2 C4.7 20.3 8 22.7 12 22.7 C16 22.7 19.3 20.3 19.3 16.2 C19.3 12.1 12 2.4 12 2.4 Z",
    ],
  },
  potassium: { // "K" — potassium balance bar
    viewBox: "0 0 24 24",
    paths: [
      "M4.8 3 H8.3 V21 H4.8 Z",
      "M8.3 12.4 L16.4 3 L20.8 3 L11.3 13.3 Z",
      "M8.3 11.6 L11.3 10.7 L20.8 21 L16.4 21 Z",
    ],
  },
};
